import React, {
  useEffect,
  useState,
} from "react";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  FiBriefcase,
  FiCheckCircle,
  FiChevronLeft,
  FiChevronRight,
  FiEye,
  FiRefreshCw,
  FiSearch,
  FiX,
} from "react-icons/fi";

import {
  fetchPlatformBusinessPartnerLeads,
  fetchPlatformBusinessPartnerLeadSummary,
  fetchPlatformBusinessPartnerLeadFilters,
  fetchPlatformBusinessPartnerLeadById,
  updatePlatformBusinessPartnerLeadStatus,
  updatePlatformBusinessPartnerLeadNotes,
  setPlatformBusinessPartnerLeadFilters,
  selectPlatformBusinessPartnerLeadState,
} from "../../../../../../store/platform/platformBusinessPartnerLeadSlice";


import "./BusinessPartnerLeadsPage.css";


const BusinessPartnerLeadsPage =
  () => {

    const dispatch =
      useDispatch();

    const {
      leads,
      selectedLead,
      summary,
      filters,
      pagination,
      filterOptions,
      listLoading,
      detailsLoading,
      actionLoading,
      error,
    } =
      useSelector(
        selectPlatformBusinessPartnerLeadState
      );

    const [
      search,
      setSearch,
    ] =
      useState(
        filters.search ||
        ""
      );

    const [
      detailsOpen,
      setDetailsOpen,
    ] =
      useState(
        false
      );

    const [
      notes,
      setNotes,
    ] =
      useState(
        ""
      );

    const load =
      () => {
        dispatch(
          fetchPlatformBusinessPartnerLeads(
            filters
          )
        );

        dispatch(
          fetchPlatformBusinessPartnerLeadSummary()
        );
      };

    useEffect(
      () => {
        dispatch(
          fetchPlatformBusinessPartnerLeadFilters()
        );
      },
      [
        dispatch,
      ]
    );

    useEffect(
      () => {
        load();
      },
      [
        dispatch,
        filters.page,
        filters.limit,
        filters.status,
        filters.tenantId,
        filters.search,
      ]
    );

    useEffect(
      () => {
        setNotes(
          selectedLead?.notes ||
          ""
        );
      },
      [
        selectedLead,
      ]
    );

    const applySearch =
      () => {
        dispatch(
          setPlatformBusinessPartnerLeadFilters({
            page:
              1,
            search:
              search.trim(),
          })
        );
      };

    const openDetails =
      async (
        id
      ) => {
        setDetailsOpen(
          true
        );

        await dispatch(
          fetchPlatformBusinessPartnerLeadById(
            id
          )
        );
      };

    const saveNotes =
      async () => {
        if (
          !selectedLead?._id
        ) {
          return;
        }

        await dispatch(
          updatePlatformBusinessPartnerLeadNotes({
            id:
              selectedLead._id,
            notes,
          })
        );
      };

    return (
      <div className="platform-business-leads-page">

        <div className="platform-leads-heading">
          <div>
            <span>
              MARKETING
            </span>

            <h2>
              Business Partner Leads
            </h2>

            <p>
              Review, qualify and convert storefront business enquiries.
            </p>
          </div>

          <button
            type="button"
            onClick={
              load
            }
          >
            <FiRefreshCw />
            Refresh
          </button>
        </div>


        <div className="platform-lead-summary-grid">
          <article>
            <span>
              Total Leads
            </span>
            <strong>
              {
                summary.total
              }
            </strong>
            <FiBriefcase />
          </article>

          <article>
            <span>
              New
            </span>
            <strong>
              {
                summary.NEW
              }
            </strong>
            <FiRefreshCw />
          </article>

          <article>
            <span>
              Qualified
            </span>
            <strong>
              {
                summary.QUALIFIED
              }
            </strong>
            <FiCheckCircle />
          </article>

          <article>
            <span>
              Converted
            </span>
            <strong>
              {
                summary.CONVERTED
              }
            </strong>
            <FiCheckCircle />
          </article>
        </div>


        <div className="platform-lead-filter-card">

          <div className="platform-lead-search">
            <FiSearch />

            <input
              value={
                search
              }
              onChange={
                (
                  event
                ) =>
                  setSearch(
                    event.target.value
                  )
              }
              onKeyDown={
                (
                  event
                ) => {
                  if (
                    event.key ===
                    "Enter"
                  ) {
                    applySearch();
                  }
                }
              }
              placeholder="Search name, mobile, email, business..."
            />

            <button
              type="button"
              onClick={
                applySearch
              }
            >
              Search
            </button>
          </div>


          <select
            value={
              filters.status
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformBusinessPartnerLeadFilters({
                    page:
                      1,
                    status:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Statuses
            </option>

            {
              filterOptions
                .statuses
                .map(
                  (
                    status
                  ) => (
                    <option
                      key={
                        status
                      }
                      value={
                        status
                      }
                    >
                      {
                        status
                      }
                    </option>
                  )
                )
            }
          </select>


          <select
            value={
              filters.tenantId
            }
            onChange={
              (
                event
              ) =>
                dispatch(
                  setPlatformBusinessPartnerLeadFilters({
                    page:
                      1,
                    tenantId:
                      event.target.value,
                  })
                )
            }
          >
            <option value="">
              All Tenants
            </option>

            {
              filterOptions
                .tenants
                .map(
                  (
                    tenant
                  ) => (
                    <option
                      key={
                        tenant._id
                      }
                      value={
                        tenant._id
                      }
                    >
                      {
                        tenant.name ||
                        tenant.legalName
                      }
                    </option>
                  )
                )
            }
          </select>
        </div>


        {
          error
            ?
            (
              <div className="platform-lead-error">
                {
                  error.message ||
                  "Unable to load leads."
                }
              </div>
            )
            :
            null
        }


        <div className="platform-lead-table-card">
          <div className="platform-lead-table-scroll">
            <table>
              <thead>
                <tr>
                  <th>
                    Customer
                  </th>
                  <th>
                    Business
                  </th>
                  <th>
                    Tenant / Source
                  </th>
                  <th>
                    Status
                  </th>
                  <th>
                    Created
                  </th>
                  <th>
                    Actions
                  </th>
                </tr>
              </thead>

              <tbody>
                {
                  listLoading
                    ?
                    (
                      <tr>
                        <td
                          colSpan="6"
                          className="platform-lead-empty"
                        >
                          Loading...
                        </td>
                      </tr>
                    )
                    :
                    leads.length ===
                      0
                      ?
                      (
                        <tr>
                          <td
                            colSpan="6"
                            className="platform-lead-empty"
                          >
                            No leads found.
                          </td>
                        </tr>
                      )
                      :
                      leads.map(
                        (
                          lead
                        ) => (
                          <tr
                            key={
                              lead._id
                            }
                          >
                            <td>
                              <strong>
                                {
                                  lead.name
                                }
                              </strong>

                              <span>
                                {
                                  lead.mobile
                                }
                              </span>

                              <small>
                                {
                                  lead.email
                                }
                              </small>
                            </td>

                            <td>
                              <strong>
                                {
                                  lead.businessName
                                }
                              </strong>

                              <span>
                                {
                                  lead.businessType ||
                                  "-"
                                }
                              </span>

                              <small>
                                {
                                  lead.city ||
                                  "-"
                                }
                              </small>
                            </td>

                            <td>
                              <strong>
                                {
                                  lead
                                    .tenantId
                                    ?.name ||
                                  "Public Storefront"
                                }
                              </strong>

                              <small>
                                {
                                  lead.sourceHost ||
                                  "-"
                                }
                              </small>
                            </td>

                            <td>
                              <span className="platform-lead-status">
                                {
                                  lead.status
                                }
                              </span>
                            </td>

                            <td>
                              {
                                lead.createdAt
                                  ?
                                  new Date(
                                    lead.createdAt
                                  )
                                    .toLocaleString()
                                  :
                                  "-"
                              }
                            </td>

                            <td>
                              <button
                                type="button"
                                className="platform-lead-view-button"
                                onClick={
                                  () =>
                                    openDetails(
                                      lead._id
                                    )
                                }
                              >
                                <FiEye />
                                View
                              </button>
                            </td>
                          </tr>
                        )
                      )
                }
              </tbody>
            </table>
          </div>


          <div className="platform-lead-pagination">
            <span>
              Page {
                pagination.page
              } / {
                pagination.totalPages
              } • {
                pagination.total
              } records
            </span>

            <div>
              <button
                type="button"
                disabled={
                  pagination.page <=
                  1
                }
                onClick={
                  () =>
                    dispatch(
                      setPlatformBusinessPartnerLeadFilters({
                        page:
                          pagination.page -
                          1,
                      })
                    )
                }
              >
                <FiChevronLeft />
              </button>

              <button
                type="button"
                disabled={
                  pagination.page >=
                  pagination.totalPages
                }
                onClick={
                  () =>
                    dispatch(
                      setPlatformBusinessPartnerLeadFilters({
                        page:
                          pagination.page +
                          1,
                      })
                    )
                }
              >
                <FiChevronRight />
              </button>
            </div>
          </div>
        </div>


        {
          detailsOpen
            ?
            (
              <div className="platform-lead-dialog-overlay">
                <div className="platform-lead-dialog">

                  <div className="platform-lead-dialog-header">
                    <div>
                      <span>
                        BUSINESS PARTNER LEAD
                      </span>

                      <h3>
                        {
                          selectedLead
                            ?.businessName ||
                          "Lead Details"
                        }
                      </h3>
                    </div>

                    <button
                      type="button"
                      onClick={
                        () =>
                          setDetailsOpen(
                            false
                          )
                      }
                    >
                      <FiX />
                    </button>
                  </div>


                  {
                    detailsLoading
                      ?
                      (
                        <div className="platform-lead-dialog-loading">
                          Loading...
                        </div>
                      )
                      :
                      selectedLead
                        ?
                        (
                          <div className="platform-lead-dialog-body">

                            <div className="platform-lead-detail-grid">
                              <div>
                                <span>
                                  Name
                                </span>
                                <strong>
                                  {
                                    selectedLead.name
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Mobile
                                </span>
                                <strong>
                                  {
                                    selectedLead.mobile
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Email
                                </span>
                                <strong>
                                  {
                                    selectedLead.email
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Business
                                </span>
                                <strong>
                                  {
                                    selectedLead.businessName
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  City
                                </span>
                                <strong>
                                  {
                                    selectedLead.city ||
                                    "-"
                                  }
                                </strong>
                              </div>

                              <div>
                                <span>
                                  Source
                                </span>
                                <strong>
                                  {
                                    selectedLead.sourceHost ||
                                    "-"
                                  }
                                </strong>
                              </div>
                            </div>


                            <div className="platform-lead-message-card">
                              <span>
                                Message
                              </span>

                              <p>
                                {
                                  selectedLead.message ||
                                  "No message provided."
                                }
                              </p>
                            </div>


                            <div className="platform-lead-action-row">
                              <select
                                value={
                                  selectedLead.status
                                }
                                onChange={
                                  (
                                    event
                                  ) =>
                                    dispatch(
                                      updatePlatformBusinessPartnerLeadStatus({
                                        id:
                                          selectedLead._id,
                                        status:
                                          event.target.value,
                                      })
                                    )
                                }
                                disabled={
                                  actionLoading
                                }
                              >
                                {
                                  filterOptions
                                    .statuses
                                    .map(
                                      (
                                        status
                                      ) => (
                                        <option
                                          key={
                                            status
                                          }
                                          value={
                                            status
                                          }
                                        >
                                          {
                                            status
                                          }
                                        </option>
                                      )
                                    )
                                }
                              </select>

                              {
                                selectedLead.status !==
                                  "CONVERTED"
                                  ?
                                  (
                                    <button
                                      type="button"
                                      className="platform-lead-convert-button"
                                      onClick={
                                        () => {
                                          window.location.href =
                                            `/platform/businesses/create?leadId=${selectedLead._id}`;
                                        }
                                      }
                                    >
                                      Convert to Tenant
                                    </button>
                                  )
                                  :
                                  null
                              }
                            </div>


                            <div className="platform-lead-notes">
                              <label>
                                Marketing Notes
                              </label>

                              <textarea
                                rows="5"
                                value={
                                  notes
                                }
                                onChange={
                                  (
                                    event
                                  ) =>
                                    setNotes(
                                      event.target.value
                                    )
                                }
                              />

                              <button
                                type="button"
                                onClick={
                                  saveNotes
                                }
                                disabled={
                                  actionLoading
                                }
                              >
                                Save Notes
                              </button>
                            </div>

                          </div>
                        )
                        :
                        null
                  }

                </div>
              </div>
            )
            :
            null
        }

      </div>
    );
  };


export default BusinessPartnerLeadsPage;
